import { IOpenParams } from 'components/Toast/provider';

interface ListenerType {
  (obj: IOpenParams): void;
}

const listeners: Array<ListenerType> = [];

export const addListener = (listener: ListenerType) => {
  listeners.push(listener);
};
export const removeListener = (listener: ListenerType) => {
  const listenerToRemove = listeners.indexOf(listener);
  if (listenerToRemove !== -1) {
    listeners.splice(listenerToRemove, 1);
  }
};

export const invokeListeners = (toastData: IOpenParams) => {
  listeners.forEach((listener) => {
    listener(toastData);
  });
};
